<p-dialog [modal]="!isForTender" [(visible)]="visible" (onHide)="resetForm()" [position]="isForTender ? tenderPosition : 'center'"
    [style]="{ width: '47rem', borderRadius: '16px' }">
    <ng-template pTemplate="header">
        <div class="flex flex-column gap-2 w-full">
            <div class="relative" *ngIf="isForTender || orderQuantity > 1">
                <p-progressBar
                    [value]="isForTender ? (tenderCounter / tenderTotal * 100) : ((currentLoadIndex - 1) / orderQuantity * 100)"
                    [showValue]="false"
                    [style]="{
                        'height': '32px',
                        'border-radius': '16px',
                        'background': 'var(--surface-200)'
                    }">
                </p-progressBar>
                <div class="absolute top-0 left-0 w-full h-full flex justify-content-center align-items-center">
                    <span class="text-white font-bold text-lg">
                        {{ isForTender ? (tenderCounter + ' of ' + tenderTotal) : ('Load ' + currentLoadIndex + ' of ' + orderQuantity) }}
                    </span>
                </div>
            </div>
        </div>
    </ng-template>
    <div class="p-1">
        <!-- Order Info Section -->
        <div class="mb-5">
            <h5 class="text-lg text-700 mb-3">Order Details</h5>
            <div class="flex gap-3">
                <div class="flex-1">
                    <p-dropdown [options]="loadType" placeholder="Load Type" [(ngModel)]="newOrder.load_type"
                        optionLabel="label" optionValue="value" class="w-full"
                        [style]="{'border-radius': '12px', 'border': '1px solid var(--surface-300)', 'font-size': '1rem'}"
                        styleClass="w-full p-2" appendTo="body">
                    </p-dropdown>
                </div>
                <div class="flex-1">
                    <p-floatLabel class="w-full">
                        <input pInputText [(ngModel)]="newOrder.pickup_number" class="w-full p-3"
                            [style]="{'border-radius': '12px', 'border': '1px solid var(--surface-300)', 'font-size': '1rem', 'text-align': 'center'}"
                            styleClass="w-full p-2" />
                        <label for="pickup_number">Pick Up Number</label>
                    </p-floatLabel>
                </div>
            </div>
        </div>

        <!-- Company Info Section -->
        <div class="mb-5">
            <h5 class="text-lg text-700 mb-4">Company Information</h5>
            <div class="flex flex-column gap-4 mb-4">
                <div class="w-full">
                    <label for="new_supplier_id" class="block text-sm font-medium mb-2">Shipper</label>
                    <p-dropdown id="new_supplier_id" [options]="supplierOptions"
                        [(ngModel)]="newOrder.supplier_selection" optionLabel="name" optionValue="value" [filter]="true"
                        [style]="{'border-radius': '12px', 'border': '1px solid var(--surface-300)', 'font-size': '1rem', 'width': '100%'}"
                        placeholder="Select a shipper" styleClass="w-full p-2"
                        (onChange)="onSupplierChange($event.value)" appendTo="body">
                    </p-dropdown>
                </div>

                <div class="w-full">
                    <label for="new_receiver_id" class="block text-sm font-medium mb-2">Receiver</label>
                    <p-dropdown id="new_receiver_id" [options]="currentReceiverOptions"
                        [(ngModel)]="newOrder.receiver_selection" optionLabel="name" optionValue="value" [filter]="true"
                        [style]="{'border-radius': '12px', 'border': '1px solid var(--surface-300)', 'font-size': '1rem', 'width': '100%'}"
                        placeholder="Select a receiver" styleClass="w-full p-2"
                        (onChange)="onReceiverChange($event.value)" appendTo="body">
                    </p-dropdown>
                </div>
            </div>

            <!-- Date Selection Row -->
            <div class="flex gap-4">
                <!-- Pickup Date -->
                <div class="flex-1">
                    <div class="w-full">
                        <p-calendar [(ngModel)]="newOrder.pickup_date" [showTime]="showPickupTimePicker"
                            dateFormat="mm/dd/yy" hourFormat="12" placeholder="Select Pick Up Date"
                            [style]="{ 'width': '100%', 'border-radius': '12px', 'font-size': '1rem'}"
                            styleClass="w-full" appendTo="body">
                        </p-calendar>
                        <div class="flex align-items-center gap-2 mt-2">
                            <p-checkbox 
                                [(ngModel)]="showPickupTimePicker" 
                                [binary]="true"
                                inputId="pickup-time-toggle">
                            </p-checkbox>
                            <label for="pickup-time-toggle" class="text-sm">Include time</label>
                        </div>
                    </div>
                </div>

                <!-- Delivery Date -->
                <div class="flex-1">
                    <div class="w-full">
                        <p-calendar [(ngModel)]="newOrder.delivery_date" [showTime]="showDeliveryTimePicker"
                            dateFormat="mm/dd/yy" hourFormat="12" placeholder="Select Delivery Date"
                            [style]="{ 'width': '100%', 'border-radius': '12px', 'font-size': '1rem'}"
                            styleClass="w-full" appendTo="body">
                        </p-calendar>
                        <div class="flex align-items-center gap-2 mt-2">
                            <p-checkbox 
                                [(ngModel)]="showDeliveryTimePicker" 
                                [binary]="true"
                                inputId="delivery-time-toggle"
                                >
                            </p-checkbox>
                            <label for="delivery-time-toggle" class="text-sm">Include time</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Notes Section -->
        <div>
            <h5 class="text-lg text-700 mb-3">Additional Notes</h5>
            <textarea pInputTextarea [(ngModel)]="newOrder.notes" placeholder="Notes (optional)" [rows]="3"
                class="w-full p-3" [style]="{'border-radius': '12px', 'border': '1px solid var(--surface-300)'}">
        </textarea>
        </div>
    </div>

    <div class="flex justify-content-between align-items-center px-5 pb-4 border-top-1 surface-border pt-4 dialog-footer">
        <div class="flex align-items-center gap-2">
            <span class="text-sm font-medium text-600 mr-1">Quantity</span>
            <p-button icon="pi pi-minus" [raised]="true" [outlined]="true" severity="primary"
                [style]="{'border-radius': '8px', 'width': '1.75rem', 'height': '1.75rem', 'padding': '0'}"
                (onClick)="orderQuantity = orderQuantity - 1"
                [disabled]="orderQuantity <= 1 || isMidMultiLoad()">
            </p-button>
            <span class="font-bold text-base px-1">{{ orderQuantity }}</span>
            <p-button icon="pi pi-plus" [raised]="true" [outlined]="true" severity="primary"
                [style]="{'border-radius': '8px', 'width': '1.75rem', 'height': '1.75rem', 'padding': '0'}"
                (onClick)="orderQuantity = orderQuantity + 1"
                [disabled]="isMidMultiLoad()">
            </p-button>
        </div>
        <div class="flex gap-3">
            <p-button label="Cancel" severity="secondary" (onClick)="resetForm()" [text]="true"
                [style]="{'border-radius': '12px'}" />
            <p-button
                [label]="orderQuantity > 1 ? 'Create Load ' + currentLoadIndex + ' of ' + orderQuantity : 'Create Order'"
                (onClick)="createOrder()" [raised]="true" [outlined]="true"
                [disabled]="!newOrder.supplier_id || !newOrder.receiver_id || !newOrder.load_type || saving"
                [loading]="saving" severity="primary"
                [style]="{'border-radius': '12px'}" />
        </div>
    </div>
</p-dialog>
